import styled from 'styled-components';
import { paddings } from '~/styled';

export const CompanyInfoLabelContainer = styled.span`
  display: flex;
  flex-direction: column;
  width: 100%;
  word-wrap: normal;
  white-space: nowrap;
  text-transform: capitalize;
  label {
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(322px - 32px);
    font-size: 20px;
    line-height: 1.2;
    font-weight: 700;
    margin-bottom: ${paddings.tinyPadding};
  }
  span {
    font-size: 14px;
    line-height: 1.5;
    font-weight: 400;
  }
`;
